// Amplify (Cognito) configuration for per-user auth.
//
// Values come from the CloudFormation Outputs (CognitoUserPoolId /
// CognitoUserPoolClientId) wired in as REACT_APP_* env vars. If they're not
// set, configuration is skipped and the app keeps running on the legacy
// shared-token path — so this can land before Cognito is deployed without
// breaking local/dev.
import {Amplify} from "aws-amplify";
import {cognitoUserPoolsTokenProvider} from "aws-amplify/auth/cognito";
// `defaultStorage` is Amplify's localStorage-backed adapter (its own default);
// `sessionStorage` is the tab-scoped one. We swap between them per the user's
// "keep me signed in" choice.
import {sessionStorage, defaultStorage} from "aws-amplify/utils";
import {getRememberDevice} from "./rememberDevice";

const userPoolId = process.env.REACT_APP_COGNITO_USER_POOL_ID;
const userPoolClientId = process.env.REACT_APP_COGNITO_CLIENT_ID;

export const isCognitoConfigured = Boolean(userPoolId && userPoolClientId);

// Point Amplify's token provider at the store that matches the user's
// "keep me signed in" choice: localStorage (survives a browser close, so the
// session is cached up to the refresh token's ~30-day lifetime) when opted in,
// else sessionStorage (cleared on close). Default is off (sessionStorage), so
// a returning user re-OTPs unless they explicitly opt in on a device they own.
// Call this again before starting an OTP challenge whenever the choice changes
// so the tokens that challenge issues land in the chosen store.
export const applyTokenStorage = (remember = getRememberDevice()) => {
  cognitoUserPoolsTokenProvider.setKeyValueStorage(
    remember ? defaultStorage : sessionStorage,
  );
};

if (isCognitoConfigured) {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        // Passwordless OTP via custom-auth challenge — no username/password.
        loginWith: {phone: true, email: true},
      },
    },
  });
  // Seed from the persisted choice so a remembered session is restored on load.
  applyTokenStorage();
} else if (process.env.NODE_ENV !== "test") {
  // eslint-disable-next-line no-console
  console.warn(
    "[auth] Cognito env vars not set; running in legacy shared-token mode.",
  );
}
